import type { TypePolicies } from '../../../utils';
import { cursorPaginationFieldPolicy } from '../../../utils/policies';

export const typePolicies: TypePolicies = {
  Project: {
    fields: {
      trashAssets: {
        ...cursorPaginationFieldPolicy(['query']),
      },
    },
  },
};
